import { BonusStatusId } from '@/enums/bonusStatusId';

export const activeUserBonusStatus = [
  BonusStatusId.Activated?.toString(),
  // BonusStatusId.Issued,
  // BonusStatusId.Supplied,
];

export const expiredUserBonusStatus = [
  BonusStatusId.Cancelled?.toString(),
  BonusStatusId.Invalidated?.toString(),
  BonusStatusId.Expired?.toString(),
];

export const inactiveUserBonusStatus = [
  BonusStatusId.Coupon?.toString(),
  BonusStatusId.Spin?.toString(),
  BonusStatusId.Ticket?.toString(),
];

export const filterActivesOnlyUserBonus = [
  ...inactiveUserBonusStatus,
  BonusStatusId.Activated?.toString(),
  // BonusStatusId.Issued,
  // BonusStatusId.Supplied,
];
